const peiProgramAreas = {
  ServicioSordos: 60,
  ServicioCiegos: 59,
  EducacionFisicaAdaptada: 31,
  OrientacionMovilidad: 33,
  Otros: 53,
  Educativo: 126,
  EducacionFisicaAdaptadaCombinada: 48,
  Ingles: 13,
};

export default peiProgramAreas;
